var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar-nav" }, [
    _c("section", [
      _c("label", [_vm._v("My account")]),
      _vm._v(" "),
      _vm.isFutureInterestEnabled
        ? _c(
            "div",
            { staticClass: "link-item" },
            [
              _c("router-link", { attrs: { to: "/my-companies" } }, [
                _vm._v("Companies"),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "link-item" },
        [
          _c("router-link", { attrs: { to: "/deals/submissions" } }, [
            _vm._v("Proposals"),
          ]),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("section", [
      _c("label", [_vm._v("Settings")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "link-item" },
        [_c("router-link", { attrs: { to: "/profile" } }, [_vm._v("Account")])],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }